module.exports = __webpack_public_path__ + "static/media/poster4.6990390e.png";